import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { FlexibleCalculationPage } from '@/areas/flexible-calculations/FlexibleCalculation/FlexibleCalculationPage';
import { canViewFlexibleCalculation } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/flexible-calculation/$flexibleCalculationId')(
    {
        staticData: { access: { permissions: canViewFlexibleCalculation }, chrome: 'project' } satisfies PageStaticData,
        validateSearch: stringSearch({ scenario: 'optional' }),
        component: RouteComponent,
    },
);

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const scenario = Route.useSearch({ select: (search) => search.scenario });
    return <FlexibleCalculationPage {...pathParams} scenario={scenario} />;
}
